import {useCallback, useEffect, useRef} from 'react';

/**
 * 현재 마운트 상태인지 확인할 수 있는 함수를 반환하는 훅
 * https://usehooks-ts.com/react-hook/use-is-mounted 참고
 */
export function useIsMounted() {
  const isMounted = useRef(false);

  useEffect(() => {
    isMounted.current = true;

    return () => {
      isMounted.current = false;
    };
  }, []);

  return useCallback(() => isMounted.current, []);
}
